<template>
  <div class="sticky-sidebar">
    <!-- Fiyat Özeti -->
    <v-card v-if="hotelBooking" class="mb-3 elevation-2">
      <div style="background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;padding:16px;">
        <div style="font-size:13px;opacity:0.8;margin-bottom:4px;">{{ $t('Hotel-Price-Summary') }}</div>
        <div style="font-size:28px;font-weight:700;">{{ footerTotalFare | moneyformat }} ₺</div>
      </div>

      <v-card-text style="padding:16px;">
        <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:10px;">
          <span style="color:#6b7280;">{{ $t('Hotel-Room-Price') }}</span>
          <span style="font-weight:600;">{{ (hotelBooking.BaseFare || hotelBooking.ArkmanPrice || 0) | moneyformat }} ₺</span>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:10px;">
          <span style="color:#6b7280;">{{ $t('Tax-v2') }}</span>
          <span style="font-weight:600;">{{ (hotelBooking.TotalTax || 0) | moneyformat }} ₺</span>
        </div>
        <div style="display:flex;justify-content:space-between;font-size:13px;padding-top:10px;border-top:1px solid #e5e7eb;margin-top:10px;">
          <span style="color:#1f2937;font-weight:600;">{{ $t('Total') }}</span>
          <span style="color:#667eea;font-weight:700;font-size:16px;">{{ footerTotalFare | moneyformat }} ₺</span>
        </div>
      </v-card-text>
    </v-card>

    <!-- Ödeme Butonları -->
    <v-card v-if="hotelBooking" class="elevation-2">
      <v-card-text style="padding:14px;">
        <template v-if="!reservationAttempted">
        <v-btn
          block
          large
          color="success"
          startCreditCardPayment
          @click="startCreditCardPayment"
          :loading="loadingvmodel"
          style="border-radius:10px;height:48px;font-weight:600;margin-bottom:8px;"
        >
          <v-icon left>account_balance_wallet</v-icon>{{ $t('Hotel-Pay-From-Current') }}
        </v-btn>
        <v-btn
          block
          large
          style="background:#667eea;color:#fff;border-radius:10px;height:48px;font-weight:600;margin-bottom:8px;"
          @click="startCurrentPayment"
          :loading="loadingvmodel"
        >
          <v-icon left>credit_card</v-icon>{{ $t('Hotel-Pay-By-Card') }}
        </v-btn>
        </template>
        <v-btn
          block
          outlined
          style="border:2px solid #e5e7eb;color:#6b7280;border-radius:10px;height:44px;font-weight:600;"
          @click="goBack"
        >
          <v-icon left>arrow_back</v-icon>{{ $t('GoBack') }}
        </v-btn>
      </v-card-text>
    </v-card>

    <!-- Otel Detayları -->
    <v-card v-if="hotelBooking" class="mt-3 elevation-1">
      <v-card-text style="padding:14px;">
        <div style="font-size:13px;font-weight:600;color:#1f2937;margin-bottom:10px;">{{ $t('Hotel-Details') }}</div>
        <div style="font-size:12px;color:#6b7280;line-height:1.6;">
          <div style="margin-bottom:8px;">
            <span style="font-weight:600;">{{ $t('Hotel-Room-Type') }}:</span> {{ hotelBooking.RoomName || $t('Hotel-Standard-Room') }}
          </div>
          <div style="margin-bottom:8px;">
            <span style="font-weight:600;">{{ $t('Hotel-Board-Type') }}:</span> {{ hotelBooking.RateName || $t('Hotel-Breakfast-Included') }}
          </div>
          <div>
            <span style="font-weight:600;">{{ $t('Hotel-Location') }}:</span> {{ hotelBooking.CityName }}, {{ hotelBooking.Country }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import helpers from "@/components/app/customcomp/helpers.js";

export default {
  name: "HotelSidebar",
  props: {
    hotelBooking: {
      type: Object,
      default: null
    },
    footerTotalFare: {
      type: Number,
      default: 0
    },
    loadingvmodel: {
      type: Boolean,
      default: false
    },
    reservationAttempted: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    startCurrentPayment() {
      this.$emit("paymentStart", { paymentType: 2 });
    },
    startCreditCardPayment() {
      this.$emit("paymentStart", { paymentType: 3 });
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  filters: {
    moneyformat(m) { return helpers.moneyformat(m); }
  }
};
</script>

<style scoped>
.sticky-sidebar {
  position: sticky;
  top: 16px;
}
</style>
